import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { Link } from "react-router-dom";
var HeroSection = function HeroSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("section", {
    className: "bg-[#E5EEFF] h- lg:h-[480px] flex items-center justify-center py-16 mb-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1152px] md:mx-auto flex flex-col items-center justify-between relative w-full gap-3 lg:flex-row-reverse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/compare/hero.png",
    alt: tShort("compare/hero_alt", {
      ns: "web_common"
    }),
    className: "object-contain lg:w-[642px] lg:h-[311px]",
    width: "386px",
    height: "188px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center lg:text-start max-w-[500px] w-full px-9"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary text-4xl font-bold mb-4"
  }, tShort("compare/hero_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-lg mb-6 text-primary"
  }, tShort("compare/hero_description", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/autos"),
    className: "bg-primary text-white hover:text-white px-6 py-3 rounded hover:bg-primary-110 transition min-w-[242px] border-none outline-none cursor-pointer w-full lg:w-fit inline-block text-center"
  }, tShort("compare/hero_cta", {
    ns: "web_common"
  })))));
};
export default HeroSection;